import React from "react";
import "./Layout.css";
import Header from "../../hs-shared/components/header";
import Footer from "../../hs-shared/components/footer";

const Layout = ({ children }) => {
  return (
    <>
      <div tabIndex="-1">
        <Header
          skipToSection="feature-area"
          showAccessibilityToolbar={true}
          showCountrySelector={false}
          cludoSearchEnabled={true}
        />
        <div id="feature-area">
          <div>{children}</div>
        </div>
        <Footer />
      </div>
    </>
  );
};

export default Layout;
